import * as THREE from 'three';
import Time from '../Utils/Time';
import Application from '../Application';
import { IDLE_FOCUS, IDLE_ORIGIN, idleCameraPosition, idleClock } from './IdlePath';
export class CameraKeyframeInstance {
    constructor(keyframe) {
        this.position = keyframe.position;
        this.focalPoint = keyframe.focalPoint;
    }
    update() { }
}
// World size and depth of the monitor screen (see MonitorScreen) and the camera FOV
const MONITOR = { w: 2464, h: 1272, z: -117 };
const FOV = 35;
const keys = {
    idle: {
        position: IDLE_ORIGIN.clone(),
        focalPoint: IDLE_FOCUS.clone(),
    },
    monitor: {
        position: new THREE.Vector3(-357, 914, 2000),
        focalPoint: new THREE.Vector3(-357, 914, MONITOR.z),
    },
    desk: {
        position: new THREE.Vector3(-357, 1800, 5500),
        focalPoint: new THREE.Vector3(-357, 500, 0),
    },
    // the loading screen already runs the idle sweep (see IdlePath.ts), so the camera never jumps when it fades
    loading: {
        position: IDLE_ORIGIN.clone(),
        focalPoint: IDLE_FOCUS.clone(),
    },
};
export class MonitorKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.monitor;
        super(keyframe);
        this.application = new Application();
        this.sizes = this.application.sizes;
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.targetPos = new THREE.Vector3().copy(keyframe.position);
    }
    update() {
        // Pull back until the whole screen fits, whichever side limits it
        const aspect = this.sizes.height / this.sizes.width;
        const fit = Math.max(MONITOR.h * 1.12, MONITOR.w * 1.04 * aspect);
        this.targetPos.z =
            MONITOR.z + fit / (2 * Math.tan((FOV / 2) * THREE.MathUtils.DEG2RAD));
        this.position.copy(this.targetPos);
    }
}
export class LoadingKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.loading;
        super(keyframe);
    }
    // follows the idle sweep at the loading screen's clock, so the room lines up with its drawing
    update() {
        idleCameraPosition(idleClock.ms, this.position);
    }
}
export class DeskKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.desk;
        super(keyframe);
        this.application = new Application();
        this.mouse = this.application.mouse;
        this.sizes = this.application.sizes;
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.targetFoc = new THREE.Vector3().copy(keyframe.focalPoint);
        this.targetPos = new THREE.Vector3().copy(keyframe.position);
    }
    update() {
        const mouseX = this.origin.x + this.mouse.x - this.sizes.width / 2;
        this.targetFoc.x += (mouseX - this.targetFoc.x) * 0.05;
        this.targetFoc.y +=
            (-(this.mouse.y - this.sizes.height) - this.targetFoc.y) * 0.05;
        this.targetPos.x += (mouseX - this.targetPos.x) * 0.025;
        this.targetPos.y +=
            (-(this.mouse.y - this.sizes.height * 2) - this.targetPos.y) *
                0.025;
        const aspect = this.sizes.height / this.sizes.width;
        this.targetPos.z = this.origin.z + aspect * 3000 - 1800;
        this.focalPoint.copy(this.targetFoc);
        this.position.copy(this.targetPos);
    }
}
export class IdleKeyframe extends CameraKeyframeInstance {
    constructor() {
        const keyframe = keys.idle;
        super(keyframe);
        this.origin = new THREE.Vector3().copy(keyframe.position);
        this.time = new Time();
    }
    // the sweep continues from where the loading screen left it (time.elapsed restarts when loading is done)
    update() {
        idleCameraPosition(this.time.elapsed + idleClock.ms, this.position);
    }
}
